<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import AccountTabs from "@/components/AccountTabs";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  components: {
    Layout,
    Breadcrumb,
    AccountTabs
  },
  data() {
    return {
      loading: false,
      form: {
        creci: "",
        company: "",
      },
    };
  },
  validations: {
    form: {
      creci: { required, maxLength: maxLength(50) },
      company: { maxLength: maxLength(255) },
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }

      this.loading = true;
      api
        .put("user", {
          section: "professional",
          creci: this.form.creci,
          company: this.form.company,
        })
        .then((response) => {
          if (response.data.status == "success") {
            // Atualiza o usuário da sessão com os novos dados profissionais
            this.$store.state.account.user = Object.assign({}, this.account.user, {
              creci: response.data.user.creci,
              company: response.data.user.company,
            });
            this.form.creci = response.data.user.creci || "";
            this.form.company = response.data.user.company || "";
            this.$v.form.$reset();
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message || "Não foi possível salvar, tente novamente.");
          }
        })
        .catch(() => {
          this.$toast.error("Não foi possível salvar, tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.form.creci = this.account.user.creci || "";
    this.form.company = this.account.user.company || "";
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Minha Conta' }, { text: 'Dados profissionais' }]" />
    <AccountTabs></AccountTabs>
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body">
            <b-form class="p-3" @submit.prevent="submit">
              <b-form-group label="CRECI" label-for="creci">
                <b-form-input id="creci" v-model="form.creci" type="text" autocomplete="off" :class="{ 'is-invalid': $v.form.creci.$error }"></b-form-input>
                <div v-if="$v.form.creci.$error" class="invalid-feedback">Informe o seu CRECI.</div>
              </b-form-group>
              <b-form-group label="Imobiliária/Incorporadora" label-for="company">
                <b-form-input id="company" v-model="form.company" type="text" autocomplete="off" :class="{ 'is-invalid': $v.form.company.$error }"></b-form-input>
                <div v-if="$v.form.company.$error" class="invalid-feedback">Máximo de 255 caracteres.</div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="loading" type="submit" variant="default">
                  Salvar
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
